import request from '@/request/request'
const getInStockRecord = async (params) => {
    let res = await request.get("/Product/getInStockRecord?productName=" + params);
    if (res.success) {
        return res.data;
    }
}
const getOutStockRecord = async (params) => {
    let res = await request.get("/Product/getOutStockRecord?productName=" + params);
    if (res.success) {
        return res.data;
    }
}
export { getInStockRecord, getOutStockRecord };